<template>
  <div class="config-container">
    <!-- 加载遮罩 -->
    <div v-if="loading" class="loading-overlay">
      <div class="loading-spinner">
        <div class="spinner"></div>
        <p>加载配置中...</p>
      </div>
    </div>
    <!-- Added config name input and save button with Apple-style header -->
    <div class="config-header">
      <div class="header-content">
        <div class="header-left">
          <h2>{{ isEditMode ? '编辑配置 - 尤弥尔传奇韩服' : '创建配置 - 尤弥尔传奇韩服' }}</h2>
          <div class="header-controls">
            <div class="config-name-group">
              <label>配置名称</label>
              <input
                v-model="configForm.name"
                type="text"
                class="config-name-input"
                placeholder="输入配置名称"
                :disabled="isEditMode && isDefaultConfig"
                :title="isEditMode && isDefaultConfig ? '默认配置不允许修改名称' : ''"
              />
            </div>
            <button
              v-if="!isSharedConfig"
              @click="saveConfig"
              :disabled="saving"
              class="save-btn"
            >
              {{ saving ? '保存中...' : (isEditMode ? '更新配置' : '保存配置') }}
            </button>
            <span v-else class="shared-config-notice">
              这是共享配置，只能查看不能修改,可以复制一份修改
            </span>
            <div class="config-description-group">
              <label>配置描述</label>
              <input
                v-model="configForm.description"
                type="text"
                class="config-description-input"
                placeholder="输入配置描述（可选）"
              />
            </div>
          </div>
        </div>
        <div class="header-notice">
          <div class="notice-content-compact">
            <p>
              <a 
                href="https://www.yuque.com/liuce1996/yeya/gvrk7rv34x21gdp8?singleDoc#" 
                target="_blank" 
                class="tutorial-text-link"
                title="查看AutoRun脚本设置教程"
              >
                📖 脚本设置教程
              </a>
            </p>
            <p>• 配置名称创建后不允许改名和删除</p>
            <p>• 每个账号都必须有一个<strong>默认配置</strong>，新创建的账号将自动使用默认配置</p>
          </div>
        </div>
      </div>
    </div>
    
    <div class="config-content">
      <!-- Tab导航 -->
      <div class="tab-container">
        <div class="tab-nav">
          <button 
            class="tab-button" 
            :class="{ active: activeTab === 'basic' }"
            @click="activeTab = 'basic'"
          >
            基础配置
          </button>
          <button 
            class="tab-button" 
            :class="{ active: activeTab === 'items' }"
            @click="activeTab = 'items'"
          >
            道具配置
          </button>
        </div>
        
        <!-- Tab内容 -->
        <div class="tab-content">
          <!-- 基础配置Tab -->
          <div v-if="activeTab === 'basic'" class="tab-pane">
            <!-- Three column layout with all sections in one row -->
            <div class="main-content-grid">
        <!-- First column: Basic settings -->
        <div class="form-section grouped-section">
          <div class="grouped-content">
            <!-- 角色模式 -->
            <div class="compact-section bordered-section">
              <h4 class="compact-title">角色模式</h4>
              <div class="compact-note">20级前均为起号模式以下配置不会生效</div>
              <div class="form-row">
                <el-radio-group v-model="configContent.characterMode" size="small">
                  <el-radio label="single">单角色模式</el-radio>
                  <el-radio label="roll2">滚2角色挖琥珀</el-radio>
                  <el-radio label="rollAccount">滚账号挖琥珀</el-radio>
                  <el-radio label="placeholder">占坑模式（比单角色模式增加自动创建角色功能）</el-radio>
                </el-radio-group>
              </div>
              <div class="form-row">
                <label>职业（占坑模式）：</label>
                <el-select v-model="configContent.createCharacter.profession" size="small" style="width: 120px;">
                  <el-option label="战士" value="战士"></el-option>
                  <el-option label="奶妈" value="奶妈"></el-option>
                  <el-option label="法师" value="法师"></el-option>
                  <el-option label="双枪" value="双枪"></el-option>
                  <el-option label="弓箭" value="弓箭"></el-option>
                </el-select>
              </div>
              <div class="form-row">
                <label>选区（占坑模式）：</label>
                <el-select v-model="configContent.placeholderZone" size="small" style="width: 180px;">
                  <el-option label="第一大区>굴베이그" value="第一大区>굴베이그"></el-option>
                  <el-option label="第一大区>베르단디" value="第一大区>베르단디"></el-option>
                  <el-option label="第二大区>우르드" value="第二大区>우르드"></el-option>
                  <el-option label="第二大区>빌란트" value="第二大区>빌란트"></el-option>
                  <el-option label="第三大区>베오울프" value="第三大区>베오울프"></el-option>
                  <el-option label="第三大区>스루드" value="第三大区>스루드"></el-option>
                  <el-option label="第四大区>헤이드룬" value="第四大区>헤이드룬"></el-option>
                  <el-option label="第四大区>하티" value="第四大区>하티"></el-option>
                  <el-option label="第五大区>마니" value="第五大区>마니"></el-option>
                  <el-option label="第五大区>스쿨드" value="第五大区>스쿨드"></el-option>
                  <el-option label="第五大区>티알피" value="第五大区>티알피"></el-option>
                  <el-option label="第六大区>카리" value="第六大区>카리"></el-option>
                  <el-option label="第六大区>솔" value="第六大区>솔"></el-option>
                </el-select>
              </div>
              <div class="form-row">
                <label>主角色位置：</label>
                <el-select v-model="configContent.mainCharacterPosition" size="small" style="width: 120px;">
                  <el-option label="第一个" value="第一个"></el-option>
                  <el-option label="第二个" value="第二个"></el-option>
                  <el-option label="第三个" value="第三个"></el-option>
                  <el-option label="第四个" value="第四个"></el-option>
                </el-select>
              </div>
            </div>
  
            <!-- 游戏更新 -->
            <div class="compact-section bordered-section">
              <h4 class="compact-title">游戏更新</h4>
              <div class="form-row">
                <el-select v-model="configContent.gameUpdate" size="small" style="width: 150px;">
                  <el-option label="gametoday" value="gametoday"></el-option>
                  <el-option label="apkpure" value="apkpure"></el-option>
                  <el-option label="谷歌" value="google"></el-option>
                  <el-option label="ACE云手机" value="ace"></el-option>
                </el-select>
                <el-checkbox v-model="configContent.autoUpdate" size="small">自动更新</el-checkbox>
              </div>
            </div>
  
            <!-- 代理软件 -->
            <div class="compact-section bordered-section">
              <h4 class="compact-title">代理软件</h4>
              <div class="form-row">
                <el-select v-model="configContent.proxyType" size="small" style="width: 120px;">
                  <el-option label="Kit代理" value="kit"></el-option>
                  <el-option label="nekobox" value="nekobox"></el-option>
                </el-select>
                <el-checkbox v-model="configContent.enableProxy" size="small">启用代理</el-checkbox>
              </div>
            </div>
  
            <!-- 主线区域 -->
            <div class="compact-section bordered-section">
              <h4 class="compact-title">主线区域</h4>
              <div class="form-row">
                <el-checkbox v-model="configContent.mainQuest.enabled" size="small">是否主线</el-checkbox>
              </div>
              <div class="form-row">
                <label>一直做到</label>
                <input 
                  type="number" 
                  v-model.number="configContent.mainQuest.level" 
                  :min="1" 
                  :max="100"
                  class="simple-number-input"
                />
                <span class="form-label">级</span>
              </div>
              <div class="form-row">
                <span class="small-text">死亡</span>
                <input 
                  type="number" 
                  v-model.number="configContent.mainQuest.deathLimit" 
                  :min="1" 
                  :max="20"
                  class="simple-number-input"
                />
                <span class="form-label">次后</span>
                <input 
                  type="number" 
                  v-model.number="configContent.mainQuest.cooldownHours" 
                  :min="1" 
                  :max="72"
                  class="simple-number-input"
                />
                <span class="form-label">小时内不再进行主线</span>
              </div>
              <div class="compact-note">提示：18级之前默认会一直做主线</div>
            </div>

            <!-- 故事&成就&黑色女武神 -->
            <div class="compact-section bordered-section">
              <h4 class="compact-title">故事&成就&黑色女武神</h4>
              <div class="checkbox-grid-2x2">
                <el-checkbox v-model="configContent.storyAchievement.exchangeTask" size="small">交易所任务</el-checkbox>
                <el-checkbox v-model="configContent.storyAchievement.ultimateTask" size="small">大招任务</el-checkbox>
                <el-checkbox v-model="configContent.storyAchievement.blueBird" size="small">蓝鸟</el-checkbox>
                <el-checkbox v-model="configContent.storyAchievement.purpleBird" size="small">紫鸟</el-checkbox>
              </div>
            </div>

            <!-- 系统设置 -->
            <div class="compact-section bordered-section">
              <h4 class="compact-title">系统设置</h4>
              <div class="form-row">
                <el-checkbox v-model="configContent.systemSettings.autoStart" size="small">开机自启动</el-checkbox>
                <el-checkbox v-model="configContent.systemSettings.ailinSystem" size="small">艾琳系统</el-checkbox>
              </div>
              <div class="form-row">
                <el-checkbox v-model="configContent.systemSettings.randomDelayStart" size="small">随机延时启动</el-checkbox>
                <el-checkbox v-model="configContent.systemSettings.autoUpdateScript" size="small">自动更新脚本（运行中不会更新，启动会强制更新）</el-checkbox>
              </div>
              <div class="form-row">
                <label class="setting-label">谷歌登录界面选择：</label>
                <el-radio-group v-model="configContent.systemSettings['谷歌登录界面选择']" size="small">
                  <el-radio value="直接登录">直接登录</el-radio>
                  <el-radio value="重启登录">重启登录</el-radio>
                  <el-radio value="停止脚本">停止脚本</el-radio>
                </el-radio-group>
              </div>
              <div class="google-login-tip">
                <div class="tip-content">
                  <span class="tip-icon">💡</span>
                  <span class="tip-text">出现停权的号可以使用停止登录防止掉授权，苹果建议使用重启防止掉授权再次登录</span>
                </div>
              </div>
            </div>

            <!-- 游戏商城（每天自动购买） - 独立框 -->
            <div class="compact-section bordered-section">
              <h4 class="compact-title">游戏商城（每天自动购买）</h4>
              <div class="compact-note">提示：小于50万银币时不再购买</div>
              <div class="shop-rows">
                <div class="checkbox-row">
                  <el-checkbox v-model="configContent.gameShop.autoBuyMana" size="small">自动商场买蓝</el-checkbox>
                </div>
                <div class="checkbox-row">
                  <el-checkbox v-model="configContent.gameShop.weaponStone" size="small">武器强化石</el-checkbox>
                  <el-checkbox v-model="configContent.gameShop.weaponStoneBox" size="small">武器强化石箱子</el-checkbox>
                </div>
                <div class="checkbox-row">
                  <el-checkbox v-model="configContent.gameShop.clothesStone" size="small">服饰强化石</el-checkbox>
                  <el-checkbox v-model="configContent.gameShop.clothesStoneBox" size="small">服饰强化石箱子</el-checkbox>
                </div>
                <div class="checkbox-row">
                  <el-checkbox v-model="configContent.gameShop.accessoryStone" size="small">饰品强化石</el-checkbox>
                  <el-checkbox v-model="configContent.gameShop.accessoryStoneBox" size="small">饰品强化石箱子</el-checkbox>
                </div>
                <div class="checkbox-row">
                  <el-checkbox v-model="configContent.gameShop.hammerStone" size="small">镐锤强化石</el-checkbox>
                  <el-checkbox v-model="configContent.gameShop.hammerStoneBox" size="small">镐锤强化石箱子</el-checkbox>
                </div>
                <div class="checkbox-row">
                  <el-checkbox v-model="configContent.gameShop.honeyWine" size="small">蜜蜂酒</el-checkbox>
                  <el-checkbox v-model="configContent.gameShop.foodPack" size="small">食物包</el-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Second column: Combined dungeon area and inventory management -->
        <div class="form-section dungeon-inventory-section">
          <h3 class="section-title">副本区域</h3>
          
          <!-- 日本-女武神的殿堂西侧 -->
          <div class="dungeon-item">
            <el-checkbox v-model="configContent.dungeons.valkyrie.enabled" size="small">日本-女武神的殿堂西侧</el-checkbox>
            <div class="dungeon-settings">
              <label>层数</label>
              <el-select v-model="configContent.dungeons.valkyrie.floor" size="small" style="width: 120px;">
                <el-option label="一层-25级" value="1"></el-option>
                <el-option label="二层-35级" value="2"></el-option>
                <el-option label="三层-45级" value="3"></el-option>
                <el-option label="四层-55级" value="4"></el-option>
                <el-option label="五层-65级" value="5"></el-option>
              </el-select>
              <label>难度</label>
              <el-select v-model="configContent.dungeons.valkyrie.difficulty" size="small" style="width: 80px;">
                <el-option label="普通" value="普通"></el-option>
                <el-option label="PVP" value="PVP"></el-option>
              </el-select>
              <label>类型</label>
              <el-select v-model="configContent.dungeons.valkyrie.type" size="small" style="width: 80px;">
                <el-option label="经验屋" value="经验屋"></el-option>
                <el-option label="琥珀屋" value="琥珀屋"></el-option>
                <el-option label="财富屋" value="财富屋"></el-option>
              </el-select>
              <el-checkbox v-model="configContent.dungeons.valkyrie.mapCircle" size="small">地图绕圈打</el-checkbox>
            </div>
          </div>
  
          <!-- 周本-西格伦的迷宫西侧 -->
          <div class="dungeon-item">
            <el-checkbox v-model="configContent.dungeons.sigren.enabled" size="small">周本-西格伦的迷宫西侧</el-checkbox>
            <div class="dungeon-settings">
              <label>层数</label>
              <el-select v-model="configContent.dungeons.sigren.floor" size="small" style="width: 120px;">
                <el-option label="一层-35级" value="1"></el-option>
                <el-option label="二层-40级" value="2"></el-option>
                <el-option label="三层-45级" value="3"></el-option>
                <el-option label="四层-50级" value="4"></el-option>
                <el-option label="五层-55级" value="5"></el-option>
                <el-option label="六层-60级" value="6"></el-option>
              </el-select>
              <label>难度</label>
              <el-select v-model="configContent.dungeons.sigren.difficulty" size="small" style="width: 80px;">
                <el-option label="普通" value="普通"></el-option>
                <el-option label="PVP" value="PVP"></el-option>
              </el-select>
              <label>定点挂机</label>
              <el-select v-model="configContent.dungeons.sigren.position" size="small" style="width: 80px;">
                <el-option label="随机" value="随机"></el-option>
                <el-option label="位置1" value="位置1"></el-option>
                <el-option label="位置2" value="位置2"></el-option>
                <el-option label="位置3" value="位置3"></el-option>
                <el-option label="位置4" value="位置4"></el-option>
                <el-option label="位置5" value="位置5"></el-option>
                <el-option label="位置6" value="位置6"></el-option>
                <el-option label="位置7" value="位置7"></el-option>
                <el-option label="位置8" value="位置8"></el-option>
                <el-option label="位置9" value="位置9"></el-option>
                <el-option label="位置10" value="位置10"></el-option>
                <el-option label="位置11" value="位置11"></el-option>
                <el-option label="位置12" value="位置12"></el-option>
                <el-option label="位置13" value="位置13"></el-option>
                <el-option label="位置14" value="位置14"></el-option>
                <el-option label="位置15" value="位置15"></el-option>
                <el-option label="位置16" value="位置16"></el-option>
                <el-option label="位置17" value="位置17"></el-option>
                <el-option label="位置18" value="位置18"></el-option>
                <el-option label="位置19" value="位置19"></el-option>
                <el-option label="位置20" value="位置20"></el-option>
              </el-select>
            </div>
          </div>
  
          <!-- 周本-波尔克房间西侧 -->
          <div class="dungeon-item">
            <el-checkbox v-model="configContent.dungeons.polk.enabled" size="small">周本-波尔克房间西侧</el-checkbox>
            <div class="dungeon-settings">
              <label>层数</label>
              <el-select v-model="configContent.dungeons.polk.floor" size="small" style="width: 120px;">
                <el-option label="一层-35级" value="1"></el-option>
                <el-option label="二层-40级" value="2"></el-option>
                <el-option label="三层-45级" value="3"></el-option>
                <el-option label="四层-50级" value="4"></el-option>
                <el-option label="五层-55级" value="5"></el-option>
                <el-option label="六层-60级" value="6"></el-option>
              </el-select>
              <label>难度</label>
              <el-select v-model="configContent.dungeons.polk.difficulty" size="small" style="width: 80px;">
                <el-option label="普通" value="普通"></el-option>
                <el-option label="PVP" value="PVP"></el-option>
              </el-select>
              <label>定点挂机</label>
              <el-select v-model="configContent.dungeons.polk.position" size="small" style="width: 80px;">
                <el-option label="随机" value="随机"></el-option>
                <el-option label="位置1" value="位置1"></el-option>
                <el-option label="位置2" value="位置2"></el-option>
                <el-option label="位置3" value="位置3"></el-option>
                <el-option label="位置4" value="位置4"></el-option>
                <el-option label="位置5" value="位置5"></el-option>
                <el-option label="位置6" value="位置6"></el-option>
                <el-option label="位置7" value="位置7"></el-option>
                <el-option label="位置8" value="位置8"></el-option>
                <el-option label="位置9" value="位置9"></el-option>
                <el-option label="位置10" value="位置10"></el-option>
                <el-option label="位置11" value="位置11"></el-option>
                <el-option label="位置12" value="位置12"></el-option>
                <el-option label="位置13" value="位置13"></el-option>
                <el-option label="位置14" value="位置14"></el-option>
                <el-option label="位置15" value="位置15"></el-option>
                <el-option label="位置16" value="位置16"></el-option>
                <el-option label="位置17" value="位置17"></el-option>
                <el-option label="位置18" value="位置18"></el-option>
                <el-option label="位置19" value="位置19"></el-option>
                <el-option label="位置20" value="位置20"></el-option>
              </el-select>
            </div>
            <div class="dungeon-settings">
              <label>类型</label>
              <el-select v-model="configContent.dungeons.polk.type" size="small" style="width: 100px;">
                <el-option label="刷怪" value="刷怪"></el-option>
                <el-option label="琥珀屋" value="全图挖琥珀"></el-option>
              </el-select>
            </div>
          </div>
  
          <!-- 其他设置移到这里 -->
          <div class="inventory-section">
            <h3 class="section-title">其他设置</h3>
            <div class="form-row">
              <el-checkbox v-model="configContent.otherRequirements.commission" size="small">委托栏任务</el-checkbox>
              <el-checkbox v-model="configContent.otherRequirements.sideQuest" size="small">支线任务</el-checkbox>
            </div>
            
            <div class="form-row">
              <span class="small-text">死亡或者任务失败</span>
              <input 
                type="number" 
                v-model.number="configContent.otherRequirements.commissionFailHours" 
                :min="3" 
                :max="48"
                class="simple-number-input"
              />
              <span class="form-label">小时内不再做 并且记录该任务</span>
            </div>
      
      
            <div class="decompose-section">
              <el-checkbox v-model="configContent.otherRequirements.autoDecomposeEquip" size="small">自动分解装备</el-checkbox>
              <div class="decompose-options">
                <el-checkbox
                  v-model="configContent.otherRequirements.decomposeSkillBook"
                  size="small"
                  :disabled="!configContent.otherRequirements.autoDecomposeEquip"
                >技能书</el-checkbox>
              </div>
            </div>

            <div class="checkbox-grid-aligned">
              <el-checkbox v-model="configContent.otherRequirements.autoEnhance" size="small">自动强化装备</el-checkbox>
              <el-checkbox v-model="configContent.otherRequirements.autoValkyrieCompose" size="small">自动女武神合成</el-checkbox>
              <el-checkbox v-model="configContent.otherRequirements.autoPetCompose" size="small">自动宠物合成</el-checkbox>
              <el-checkbox v-model="configContent.otherRequirements.autoEquipValkyrie" size="small">自动穿戴女武神卡</el-checkbox>
              <el-checkbox v-model="configContent.otherRequirements.autoEquipPet" size="small">自动穿戴宠物</el-checkbox>
              <el-checkbox v-model="configContent.otherRequirements.autoAmberBox" size="small">自动琥珀封箱</el-checkbox>
              <el-checkbox v-model="configContent.otherRequirements.autoEquipBox" size="small">自动开装备箱子</el-checkbox>
              <el-checkbox v-model="configContent.otherRequirements.autoMaterialCompose" size="small">自动合成材料</el-checkbox>
              <el-checkbox v-model="configContent.otherRequirements.autoBuySkill" size="small">自动购买技能</el-checkbox>
              <el-checkbox v-model="configContent.otherRequirements.autoWarehouse" size="small">自动仓库</el-checkbox>
              <el-checkbox v-model="configContent.otherRequirements.autoUltimate" size="small">自动释放大招</el-checkbox>
            </div>

            <div class="form-row" style="margin-top: 12px;">
              <el-checkbox v-model="configContent.otherRequirements.silverRestoreEnabled" size="small">银币恢复经验</el-checkbox>
              <input
                v-if="configContent.otherRequirements.silverRestoreEnabled"
                type="number"
                v-model.number="configContent.otherRequirements.silverRestore"
                :min="0"
                :max="999999999"
                class="simple-number-input"
                style="width: 120px;"
              />
            </div>
            <div class="form-row" style="margin-top: 12px;">
              <el-checkbox v-model="configContent.otherRequirements.seasonInstruction" size="small">赛季指令</el-checkbox>
            </div>
            
          </div>

          <!-- 收藏区域 -->
          <div class="inventory-section">
            <h3 class="section-title">收藏区域</h3>
            <div class="form-row">
              <el-checkbox v-model="configContent.collection.enabled" size="small">收藏开关</el-checkbox>
            </div>
            
            <div class="form-row">
              <span class="form-label">只收藏</span>
              <input 
                type="number" 
                v-model.number="configContent.collection.maxPrice" 
                :min="0.01" 
                :max="99.99"
                :step="0.01"
                class="simple-number-input"
                style="width: 70px;"
              />
              <span class="form-label">钻以内道具</span>
            </div>
      
            <div class="form-row">
              <span class="form-label">装备品质：</span>
              <el-checkbox v-model="configContent.collection.equipmentQuality.white" size="small">白</el-checkbox>
              <el-checkbox v-model="configContent.collection.equipmentQuality.green" size="small">绿</el-checkbox>
              <el-checkbox v-model="configContent.collection.equipmentQuality.blue" size="small">蓝</el-checkbox>
            </div>

            <!-- 交易所 -->
            <div class="compact-section bordered-section">
              <h4 class="compact-title">交易所</h4>
              <div class="form-row">
                <el-checkbox v-model="configContent.tradingPost.autoSell" size="small">自动出售物品</el-checkbox>
                <el-checkbox v-model="configContent.tradingPost.prioritizeAmberBox" size="small">优先上架琥珀箱</el-checkbox>
              </div>
              <div class="form-row">
                <label class="form-label">最低出售</label>
                <input 
                  type="number" 
                  v-model.number="configContent.tradingPost.minPrice" 
                  :min="1"
                  :max="1000"
                  class="simple-number-input"
                />
                <span class="form-label">钻石的物品</span>
              </div>
              <div class="form-row">
                <el-checkbox v-model="configContent.tradingPost.enablePriceDifference" size="small">比当前最低价少</el-checkbox>
                <input 
                  type="number" 
                  v-model.number="configContent.tradingPost.priceDifference" 
                  :min="1"
                  :max="50"
                  class="simple-number-input"
                />
                <span class="form-label">钻上架</span>
              </div>
              <div class="form-row">
                <span class="form-label">下架超过</span>
                <input 
                  type="number" 
                  v-model.number="configContent.tradingPost.delistHours" 
                  :min="1"
                  :max="48"
                  class="simple-number-input"
                  style="width: 50px;"
                />
                <span class="form-label">小时的商品</span>
              </div>
            </div>
          </div>
        </div>
  
        <!-- Third column: Right side sections in unified container -->
        <div class="form-section grouped-section">
          <div class="right-sections-content">
            <!-- 野外挂机 -->
            <div class="compact-section bordered-section">
              <h4 class="compact-title">野外挂机</h4>
              
              <!-- 普通地图区域 -->
              <div class="outdoor-subsection">
                <h5 class="subsection-title">普通地图</h5>
                <div class="form-row single-line">
                  <label>类型：</label>
                  <el-select v-model="configContent.outdoor.type" size="small" style="width: 120px;" @change="onOutdoorTypeChange">
                    <el-option label="野外开箱子" value="chest"></el-option>
                    <el-option label="野外挂机" value="hang"></el-option>
                    <el-option label="迷宫挂机" value="maze"></el-option>
                  </el-select>
                  <el-select v-model="configContent.outdoor.location" size="small" style="width: 150px;" v-if="configContent.outdoor.type">
                    <el-option 
                      v-for="option in outdoorOptions" 
                      :key="option.value" 
                      :label="option.label" 
                      :value="option.value">
                    </el-option>
                  </el-select>
                </div>
                <!-- 野外开箱子防封策略说明 -->
                <div v-if="configContent.outdoor.type === 'chest'" class="form-row anti-ban-notice">
                  <div class="anti-ban-content">
                    <i class="el-icon-shield" style="color: #10b981; margin-right: 6px;"></i>
                  </div>
                </div>
                <!-- 野外挖琥珀防封策略说明 -->
                <div v-if="configContent.outdoor.type === 'amber'" class="form-row anti-ban-notice">
                  <div class="anti-ban-content">
                    <i class="el-icon-shield" style="color: #10b981; margin-right: 6px;"></i>
                    <span class="anti-ban-text">
                      <strong>防封策略：</strong>路径最优算法：采用距离优化算法选择最近的4个未访问采集点，结合随机选择确保每个账号的采集路径都是独特且不可预测的，有效模拟真实玩家行为避免被检测。
                    </span>
                  </div>
                </div>
                <div class="form-row" v-if="configContent.outdoor.type === 'hang' || configContent.outdoor.type === 'maze'">
                  <label>定点挂机：</label>
                  <el-select v-model="configContent.outdoor.position" size="small" style="width: 80px;">
                    <el-option label="随机" value="随机"></el-option>
                    <el-option label="位置1" value="位置1"></el-option>
                    <el-option label="位置2" value="位置2"></el-option>
                    <el-option label="位置3" value="位置3"></el-option>
                    <el-option label="位置4" value="位置4"></el-option>
                    <el-option label="位置5" value="位置5"></el-option>
                    <el-option label="位置6" value="位置6"></el-option>
                    <el-option label="位置7" value="位置7"></el-option>
                    <el-option label="位置8" value="位置8"></el-option>
                    <el-option label="位置9" value="位置9"></el-option>
                    <el-option label="位置10" value="位置10"></el-option>
                    <el-option label="位置11" value="位置11"></el-option>
                    <el-option label="位置12" value="位置12"></el-option>
                    <el-option label="位置13" value="位置13"></el-option>
                    <el-option label="位置14" value="位置14"></el-option>
                    <el-option label="位置15" value="位置15"></el-option>
                    <el-option label="位置16" value="位置16"></el-option>
                    <el-option label="位置17" value="位置17"></el-option>
                    <el-option label="位置18" value="位置18"></el-option>
                    <el-option label="位置19" value="位置19"></el-option>
                    <el-option label="位置20" value="位置20"></el-option>                  </el-select>
                </div>
                <div class="form-row">
                  <el-checkbox v-model="configContent.outdoor.autoChest" size="small">银币低于5万就去开箱子卖银币 开6小时</el-checkbox>
                </div>
              </div>

              <!-- 挖琥珀区域 -->
              <div class="outdoor-subsection">
                <h5 class="subsection-title">挖琥珀区域</h5>
                <div class="compact-note" style="margin-bottom: 10px;">
                  <i class="el-icon-info" style="color: #409EFF; margin-right: 6px;"></i>
                  <strong>提示：</strong>建议每天只挖4小时，长时间挖矿可能会判定封号
                </div>
                <div class="form-row">
                  <el-checkbox v-model="configContent.outdoor.amber.enabled" size="small">启用挖琥珀</el-checkbox>
                </div>
                <!-- 时间设置 -->
                <div class="time-settings">
                  <el-checkbox v-model="configContent.outdoor.amber.timeLimit.enabled" size="small">指定时间执行（包括开始和结束的小时）</el-checkbox>
                  <div v-if="configContent.outdoor.amber.timeLimit.enabled" class="time-range">
                    <el-select
                      v-model="configContent.outdoor.amber.timeLimit.startTime"
                      placeholder="开始"
                      size="small"
                      style="width: 60px;"
                    >
                      <el-option v-for="hour in 24" :key="hour-1" :label="(hour-1).toString().padStart(2, '0')" :value="(hour-1).toString().padStart(2, '0') + ':00'" />
                    </el-select>
                    <span class="time-separator">至</span>
                    <el-select
                      v-model="configContent.outdoor.amber.timeLimit.endTime"
                      placeholder="结束"
                      size="small"
                      style="width: 60px;"
                    >
                      <el-option v-for="hour in 24" :key="hour-1" :label="(hour-1).toString().padStart(2, '0')" :value="(hour-1).toString().padStart(2, '0') + ':00'" />
                    </el-select>
                  </div>
                </div>
                <div class="form-row single-line">
                  <label>地图：</label>
                  <el-select v-model="configContent.outdoor.amber.location" size="small" style="width: 150px;">
                    <el-option label="世界树一层" value="世界树一层"></el-option>
                    <el-option label="世界树二层" value="世界树二层"></el-option>
                    <el-option label="世界树三层" value="世界树三层"></el-option>
                    <el-option label="世界树四层" value="世界树四层"></el-option>
                    <el-option label="世界树五层" value="世界树五层"></el-option>
                  </el-select>
                  <span class="inline-notice">
                    <i class="el-icon-info" style="color: #409eff; margin-left: 12px; margin-right: 4px;"></i>
                    <span style="color: #666; font-size: 12px;">提示：挖满会去挂机</span>
                  </span>
                </div>
              </div>

              <!-- 激战地区域 -->
              <div class="outdoor-subsection">
                <h5 class="subsection-title">激战地</h5>
                <div class="form-row">
                  <el-checkbox v-model="configContent.outdoor.battleground.enabled" size="small">启用激战地挂机</el-checkbox>
                </div>
                <!-- 时间设置 -->
                <div class="time-settings">
                  <el-checkbox v-model="configContent.outdoor.battleground.timeLimit.enabled" size="small">指定时间执行（包括开始和结束的小时）</el-checkbox>
                  <div v-if="configContent.outdoor.battleground.timeLimit.enabled" class="time-range">
                    <el-select
                      v-model="configContent.outdoor.battleground.timeLimit.startTime"
                      placeholder="开始"
                      size="small"
                      style="width: 60px;"
                    >
                      <el-option v-for="hour in 24" :key="hour-1" :label="(hour-1).toString().padStart(2, '0')" :value="(hour-1).toString().padStart(2, '0') + ':00'" />
                    </el-select>
                    <span class="time-separator">至</span>
                    <el-select
                      v-model="configContent.outdoor.battleground.timeLimit.endTime"
                      placeholder="结束"
                      size="small"
                      style="width: 60px;"
                    >
                      <el-option v-for="hour in 24" :key="hour-1" :label="(hour-1).toString().padStart(2, '0')" :value="(hour-1).toString().padStart(2, '0') + ':00'" />
                    </el-select>
                  </div>
                </div>
                <div class="form-row single-line">
                  <label>地图：</label>
                  <el-select v-model="configContent.outdoor.battleground.location" size="small" style="width: 150px;">
                    <el-option label="40～57级激战地" value="40级激战地"></el-option>
                    <el-option label="45～60级激战地" value="45级激战地"></el-option>
                    
                  </el-select>
                </div>
                <div class="form-row">
                  <label>定点挂机：</label>
                  <el-select v-model="configContent.outdoor.battleground.position" size="small" style="width: 80px;">
                    <el-option label="随机" value="随机"></el-option>
                    <el-option label="位置1" value="位置1"></el-option>
                    <el-option label="位置2" value="位置2"></el-option>
                    <el-option label="位置3" value="位置3"></el-option>
                    <el-option label="位置4" value="位置4"></el-option>
                    <el-option label="位置5" value="位置5"></el-option>
                    <el-option label="位置6" value="位置6"></el-option>
                    <el-option label="位置7" value="位置7"></el-option>
                    <el-option label="位置8" value="位置8"></el-option>
                    <el-option label="位置9" value="位置9"></el-option>
                    <el-option label="位置10" value="位置10"></el-option>
                    <el-option label="位置11" value="位置11"></el-option>
                    <el-option label="位置12" value="位置12"></el-option>
                    <el-option label="位置13" value="位置13"></el-option>
                    <el-option label="位置14" value="位置14"></el-option>
                    <el-option label="位置15" value="位置15"></el-option>
                    <el-option label="位置16" value="位置16"></el-option>
                    <el-option label="位置17" value="位置17"></el-option>
                    <el-option label="位置18" value="位置18"></el-option>
                    <el-option label="位置19" value="位置19"></el-option>
                    <el-option label="位置20" value="位置20"></el-option>
                  </el-select>
                </div>
                <div class="form-row">
                  <span class="form-label">死亡</span>
                  <input 
                    type="number" 
                    v-model.number="configContent.outdoor.battleground.deathCount" 
                    :min="1" 
                    :max="20"
                    class="simple-number-input"
                  />
                  <span class="form-label">次后去普通地图挂机</span>
                </div>
              </div>
            </div>
  
            <!-- 挂机设置 -->
            <div class="compact-section bordered-section">
              <h4 class="compact-title">挂机设置</h4>
              <div class="form-row">
                <el-checkbox v-model="configContent.hangSettings.autoBuyPotion" size="small">自动买药</el-checkbox>
                <span class="form-label">间隔</span>
                <input 
                  type="number" 
                  v-model.number="configContent.hangSettings.potionInterval" 
                  :min="1" 
                  :max="24"
                  class="simple-number-input"
                  style="width: 50px;"
                />
                <span class="form-label">小时</span>
              </div>
              <div class="form-row">
                <el-checkbox v-model="configContent.hangSettings.powerSaveMode" size="small">开启省电模式</el-checkbox>
              </div>
              <div class="form-row">
                <el-checkbox v-model="configContent.hangSettings.nightMode" size="small">夜晚模式</el-checkbox>
                <div class="night-mode-notice">
                  <span class="notice-text">半夜减少脚本操作，仅买药和省电挂机</span>
                </div>
              </div>
              <div class="form-row">
                <label>血量低于</label>
                <input 
                  type="number" 
                  v-model.number="configContent.hangSettings.healthThreshold" 
                  :min="1" 
                  :max="100"
                  class="simple-number-input"
                />
                <span class="form-label">%自动回城</span>
              </div>
            </div>
  
            <!-- 工会 -->
            <div class="compact-section bordered-section">
              <h4 class="compact-title">工会</h4>
              <div class="form-row">
                <el-checkbox v-model="configContent.guild.autoJoin" size="small">自动加入工会</el-checkbox>
                <el-checkbox v-model="configContent.guild.techContribute24" size="small">24次科技捐献</el-checkbox>
              </div>
              <div class="form-row">
                <el-checkbox v-model="configContent.guild.silverContribute" size="small">银币捐献</el-checkbox>
                <el-checkbox v-model="configContent.guild.collectGuildChest" size="small">领取工会箱子</el-checkbox>
              </div>
              <div class="form-row">
                <el-checkbox v-model="configContent.guild.guildHelp" size="small">工会帮助</el-checkbox>
              </div>
            </div>
  
            
            <!-- BOSS区域 -->
            <div class="compact-section bordered-section">
              <h4 class="compact-title">BOSS区域</h4>
              <div class="boss-time-notice">
                <div class="notice-content">
                  <i class="el-icon-info" style="color: #409EFF; margin-right: 6px;"></i>
                  <span class="notice-text">
                    <strong>提示：</strong>会在野外挂机和挖琥珀执行时间之内进行远征
                  </span>
                </div>
              </div>
              <div class="form-row expedition-5-row">
                <div class="expedition-setting">
                  <el-checkbox v-model="configContent.bossArea.expedition5.enabled" size="small">远征5人</el-checkbox>
                  <el-select 
                    v-model="configContent.bossArea.expedition5.level" 
                    size="small" 
                    style="width: 85px;" 
                    :disabled="!configContent.bossArea.expedition5.enabled"
                  >
                    <el-option label="智能选择" value="auto" />
                    <el-option label="28级五人副本" value="28" />
                    <el-option label="35级五人副本" value="35" />
                    <el-option label="40级五人副本" value="40" />
                    <el-option label="45级五人副本" value="45" />
                    <el-option label="50级五人副本" value="50" />
                    <el-option label="55级五人副本" value="55" />
                    <el-option label="60级五人副本" value="60" />
                    <el-option label="65级五人副本" value="65" />
                    <el-option label="70级五人副本" value="70" />
                    <el-option label="75级五人副本" value="75" />
                  </el-select>
                  <el-checkbox 
                    v-model="configContent.bossArea.expedition5.createRoom" 
                    size="small" 
                    :disabled="!configContent.bossArea.expedition5.enabled"
                    class="expedition-inline-option"
                  >
                    没有队伍就开房间
                  </el-checkbox>
                </div>
              </div>
              <div class="form-row">
                <div class="expedition-setting">
                  <el-checkbox v-model="configContent.bossArea.expedition15.enabled" size="small">远征15人</el-checkbox>
                  <el-select 
                    v-model="configContent.bossArea.expedition15.level" 
                    size="small" 
                    style="width: 85px;" 
                    :disabled="!configContent.bossArea.expedition15.enabled"
                  >
                    <el-option label="智能选择" value="auto" />
                    <el-option label="33级十五人副本" value="33" />
                    <el-option label="38级十五人副本" value="38" />
                    <el-option label="43级十五人副本" value="43" />
                    <el-option label="48级十五人副本" value="48" />
                    <el-option label="53级十五人副本" value="53" />
                    <el-option label="58级十五人副本" value="58" />
                    <el-option label="70级十五人副本" value="70" />
                    <el-option label="80级十五人副本" value="80" />
                  </el-select>
                  <el-checkbox 
                    v-model="configContent.bossArea.expedition15.createRoom" 
                    size="small" 
                    :disabled="!configContent.bossArea.expedition15.enabled"
                    class="expedition-inline-option"
                  >
                    没有队伍就开房间
                  </el-checkbox>
                </div>
              </div>
              <div class="form-row">
                <el-checkbox v-model="configContent.bossArea.worldBoss" size="small">世界boss</el-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
  

          </div>
          
          <!-- 道具配置Tab -->
          <div v-if="activeTab === 'items'" class="tab-pane">
            <div class="items-config-container">

              <!-- 需要存仓库的道具 -->
              <div class="form-section full-width">
                <div class="section-header">
                  <h3 class="section-title">需要存仓库的道具</h3>
                  <button 
                    class="select-all-btn"
                    @click="toggleSelectAllWarehouse"
                    :disabled="warehouseItems.length === 0"
                  >
                    {{ isAllWarehouseSelected ? '取消全选' : '全选' }}
                  </button>
                </div>
                <div class="item-grid">
                  <div 
                    v-for="item in warehouseItems" 
                    :key="item.id" 
                    class="item-container"
                    :class="{ 
                      selected: configContent.warehouseItems.includes(item.id),
                      'grade-advanced': getItemGrade(item.item_name) === 'advanced',
                      'grade-intermediate': getItemGrade(item.item_name) === 'intermediate',
                      'grade-basic': getItemGrade(item.item_name) === 'basic'
                    }"
                    @click="toggleWarehouseItem(item.id)"
                  >
                    <div class="item-icon" :class="getItemBackgroundColorClass(item.background_color)">
                      <img :src="item.icon_url" :alt="item.item_name" @error="handleImageError" />
                      <div class="item-checkbox">
                        <el-checkbox 
                          :model-value="configContent.warehouseItems.includes(item.id)"
                          size="small"
                        ></el-checkbox>
                      </div>
                    </div>
                    <div class="item-name">{{ item.item_name }}</div>
                  </div>
                </div>
                <div v-if="warehouseItems.length === 0" class="empty-items">
                  暂无可存仓库的道具
                </div>
              </div>

              <!-- 需要删除的垃圾道具 -->
              <div class="form-section full-width">
                <div class="section-header">
                  <h3 class="section-title">需要删除的垃圾道具</h3>
                  <button 
                    class="select-all-btn"
                    @click="toggleSelectAllDelete"
                    :disabled="deleteItems.length === 0"
                  >
                    {{ isAllDeleteSelected ? '取消全选' : '全选' }}
                  </button>
                </div>
                <div class="item-grid">
                  <div 
                    v-for="item in deleteItems" 
                    :key="item.id" 
                    class="item-container"
                    :class="{ 
                      selected: configContent.deleteItems.includes(item.id),
                      'grade-advanced': getItemGrade(item.item_name) === 'advanced',
                      'grade-intermediate': getItemGrade(item.item_name) === 'intermediate',
                      'grade-basic': getItemGrade(item.item_name) === 'basic'
                    }"
                    @click="toggleDeleteItem(item.id)"
                  >
                    <div class="item-icon" :class="getItemBackgroundColorClass(item.background_color)">
                      <img :src="item.icon_url" :alt="item.item_name" @error="handleImageError" />
                      <div class="item-checkbox">
                        <el-checkbox 
                          :model-value="configContent.deleteItems.includes(item.id)"
                          size="small"
                        ></el-checkbox>
                      </div>
                    </div>
                    <div class="item-name">{{ item.item_name }}</div>
                  </div>
                </div>
                <div v-if="deleteItems.length === 0" class="empty-items">
                  暂无可删除的道具
                </div>
              </div>

              <!-- 需要使用的道具 -->
              <div class="form-section full-width">
                <div class="section-header">
                  <h3 class="section-title">需要使用的道具</h3>
                  <button 
                    class="select-all-btn"
                    @click="toggleSelectAllUse"
                    :disabled="useItems.length === 0"
                  >
                    {{ isAllUseSelected ? '取消全选' : '全选' }}
                  </button>
                </div>
                <div class="item-grid">
                  <div 
                    v-for="item in useItems" 
                    :key="item.id" 
                    class="item-container"
                    :class="{ 
                      selected: configContent.useItems && configContent.useItems.includes(item.id),
                      'grade-advanced': getItemGrade(item.item_name) === 'advanced',
                      'grade-intermediate': getItemGrade(item.item_name) === 'intermediate',
                      'grade-basic': getItemGrade(item.item_name) === 'basic'
                    }"
                    @click="toggleUseItem(item.id)"
                  >
                    <div class="item-icon" :class="getItemBackgroundColorClass(item.background_color)">
                      <img :src="item.icon_url" :alt="item.item_name" @error="handleImageError" />
                      <div class="item-checkbox">
                        <el-checkbox 
                          :model-value="configContent.useItems && configContent.useItems.includes(item.id)"
                          size="small"
                        ></el-checkbox>
                      </div>
                    </div>
                    <div class="item-name">{{ item.item_name }}</div>
                  </div>
                </div>
                <div v-if="useItems && useItems.length === 0" class="empty-items">
                  暂无可使用的道具
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { ElMessage } from 'element-plus'
import { getConfig, createConfig, updateConfig } from '@/api/configs'
import { gameItemsAPI } from '@/api/gameItems'

export default {
  name: 'CreateConfig',
  props: {
    id: {
      type: String,
      default: null
    }
  },
  setup(props) {
    const router = useRouter()
    const route = useRoute()
    const saving = ref(false)
    const loading = ref(false)
    const activeTab = ref('basic') // 默认显示基础配置

    // 判断是否为编辑模式
    const isEditMode = computed(() => !!props.id)
    const isDefaultConfig = ref(false)
    const isSharedConfig = ref(false) // 是否为共享配置（不是自己的）
      
    // 配置表单
    const configForm = ref({
      name: isEditMode.value ? '' : '配置001',
      description: ''
    })
      
    // 配置内容
    const configContent = ref({
      characterMode: 'single',
      mainCharacterPosition: '第一个',
      placeholderZone: '第一大区>굴베이그',
      createCharacter: {
        enabled: false,
        profession: '奶妈'
      },
      gameUpdate: 'gametoday',
      autoUpdate: true,
      proxyType: 'kit',
      enableProxy: false,
      mainQuest: {
        enabled: true,
        level: 20,
        deathLimit: 3,
        cooldownHours: 6
      },
      storyAchievement: {
        exchangeTask: false,
        ultimateTask: false,
        blueBird: false,
        purpleBird: false
      },
      systemSettings: {
        autoStart: false,
        ailinSystem: false,
        randomDelayStart: false,
        autoUpdateScript: false,
        "谷歌登录界面选择": "直接登录"
      },
      gameShop: {
        autoBuyMana: false,
        weaponStone: false,
        clothesStone: false,
        accessoryStone: false,
        hammerStone: false,
        weaponStoneBox: false,
        clothesStoneBox: false,
        accessoryStoneBox: false,
        hammerStoneBox: false,
        honeyWine: false,
        foodPack: false
      },
      dungeons: {
        valkyrie: {
          enabled: true,
          floor: '1',
          difficulty: '普通',
          type: '经验屋',
          mapCircle: false,
          timeLimit: {
            enabled: false,
            startTime: '09:00',
            endTime: '18:00'
          }
        },
        sigren: {
          enabled: true,
          floor: '1',
          difficulty: '普通',
          position: '随机',
          timeLimit: {
            enabled: false,
            startTime: '09:00',
            endTime: '18:00'
          }
        },
        polk: {
          enabled: true,
          floor: '1',
          difficulty: '普通',
          position: '随机',
          type: '刷怪',
          timeLimit: {
            enabled: false,
            startTime: '09:00',
            endTime: '18:00'
          }
        }
      },
      outdoor: {
        type: 'hang',
        location: '伊顿的峡谷',
        position: '随机',
        autoChest: false,
        timeLimit: {
          enabled: false,
          startTime: '09:00',
          endTime: '18:00'
        },
        amber: {
          enabled: false,
          location: '世界树一层',
          timeLimit: {
            enabled: false,
            startTime: '09:00',
            endTime: '18:00'
          }
        },
        battleground: {
          enabled: false,
          location: '45级激战地',
          position: '随机',
          deathCount: 3,
          timeLimit: {
            enabled: false,
            startTime: '09:00',
            endTime: '18:00'
          }
        }
      },
      hangSettings: {
        autoBuyPotion: true,
        powerSaveMode: true,
        healthThreshold: 30,
        potionInterval: 4,
        nightMode: false
      },
      otherRequirements: {
        commission: true,
        sideQuest: true,
        commissionFailHours: 3,
        autoDecomposeEquip: true,
        decomposeSkillBook: false,
        autoEnhance: true,
        autoValkyrieCompose: true,
        autoPetCompose: true,
        autoEquipValkyrie: true,
        autoEquipPet: true,
        autoAmberBox: false,
        autoEquipBox: false,
        autoMaterialCompose: false,
        autoBuySkill: false,
        autoWarehouse: false,
        autoUltimate: false,
        silverRestoreEnabled: false,
        silverRestore: 20000,
        seasonInstruction: false
      },
      guild: {
        autoJoin: true,
        techContribute24: true,
        silverContribute: false,
        collectGuildChest: false,
        guildHelp: false
      },
      tradingPost: {
        autoSell: true,
        minPrice: 10,
        prioritizeAmberBox: false,
        enablePriceDifference: false,
        priceDifference: 1,
        delistHours: 5
      },
      collection: {
        enabled: false,
        maxPrice: 0.5,
        equipmentQuality: {
          white: true,
          green: true,
          blue: false
        }
      },
      bossArea: {
        expedition5: {
          enabled: false,
          level: 'auto',
          createRoom: false
        },
        expedition15: {
          enabled: false,
          level: 'auto',
          createRoom: false
        },
        worldBoss: false,
        timeLimit: {
          enabled: false,
          startTime: '09:00',
          endTime: '18:00'
        }
      },
      warehouseItems: [], // 需要存仓库的道具ID列表
      deleteItems: [], // 需要删除的垃圾道具ID列表
      useItems: [] // 需要使用的道具ID列表
    })
  
    // 野外挂机选项
    const outdoorOptionsMap = {
      chest: [
        { label: '30级地图', value: '30级地图' },
        { label: '32级地图', value: '32级地图' },
        { label: '40级激战地', value: '40级激战地' }
      ],
      amber: [
        { label: '世界树一层', value: '世界树一层' },
        { label: '世界树二层', value: '世界树二层' },
        { label: '世界树三层', value: '世界树三层' },
        { label: '世界树四层', value: '世界树四层' },
        { label: '世界树五层', value: '世界树五层' }
      ],
      hang: [
        { label: '伊顿的峡谷-13级', value: '伊顿的峡谷' },
        { label: '乌坦加尔德-15级', value: '乌坦加尔德' },
        { label: '巨魔遗址下层25级', value: '巨魔遗址下层' },
        { label: '格拉西尔森林-30级', value: '格拉西尔森林' },
        { label: '世界树一层-35级', value: '世界树一层' },
        { label: '世界树二层-40级', value: '世界树二层' },
        { label: '世界树三层-45级', value: '世界树三层' },
        { label: '世界树四层-50级', value: '世界树四层' },
        { label: '世界树五层-55级', value: '世界树五层' },
      ],
      maze: [
        { label: '斯巴达的迷宫一层-28级', value: '斯巴达的迷宫一层-28级' },
        { label: '斯巴达的迷宫二层-35级', value: '斯巴达的迷宫二层-35级' },
        { label: '斯巴达的迷宫三层-40级', value: '斯巴达的迷宫三层-40级' },
        { label: '斯巴达的迷宫四层-45级', value: '斯巴达的迷宫四层-45级' },
        { label: '斯巴达的迷宫五层-50级', value: '斯巴达的迷宫五层-50级' },
        { label: '卡拉的迷宫一层-35级', value: '卡拉的迷宫一层-35级' },
        { label: '卡拉的迷宫二层-40级', value: '卡拉的迷宫二层-40级' },
        { label: '卡拉的迷宫三层-45级', value: '卡拉的迷宫三层-45级' },
        { label: '卡拉的迷宫四层-50级', value: '卡拉的迷宫四层-50级' },
        { label: '卡拉的迷宫五层-55级', value: '卡拉的迷宫五层-55级' }
      ]
    }
  
    const outdoorOptions = computed(() => {
      return outdoorOptionsMap[configContent.value.outdoor.type] || []
    })
  
    // 道具数据
    const warehouseItems = ref([]) // 需要存仓库的道具
    const deleteItems = ref([]) // 需要删除的垃圾道具
    const useItems = ref([]) // 需要使用的道具
  
    // 野外类型改变时重置位置
    const onOutdoorTypeChange = () => {
      configContent.value.outdoor.location = ''
    }
  
    // 加载道具数据
    const loadGameItems = async () => {
      try {
        const response = await gameItemsAPI.getGameItems('尤弥尔传奇韩服')
        const allItems = response.data.data || response.data || []
        
        // 按背景色排序函数
        const sortByBackgroundColor = (items) => {
          const colorOrder = {
            '': 0,           // 白色（无背景色）
            null: 0,
            undefined: 0,
            'light-green': 1, // 绿色
            'light-blue': 2,  // 蓝色
            'light-purple': 3, // 紫色
            'light-gold': 4   // 金色
          }
          return items.sort((a, b) => {
            const orderA = colorOrder[a.background_color] ?? 0
            const orderB = colorOrder[b.background_color] ?? 0
            return orderA - orderB
          })
        }
        
        // 过滤需要存仓库的道具：status=1 且 is_warehouse=1
        warehouseItems.value = sortByBackgroundColor(allItems.filter(item => 
          item.status === 1 && item.is_warehouse === 1
        ))
        
        // 过滤需要删除的垃圾道具：status=1 且 is_delete=1
        deleteItems.value = sortByBackgroundColor(allItems.filter(item => 
          item.status === 1 && item.is_delete === 1
        ))
        
        // 过滤需要使用的道具：status=1 且 is_use=1
        useItems.value = sortByBackgroundColor(allItems.filter(item => 
          item.status === 1 && item.is_use === 1
        ))
        
        console.log('加载道具数据:', {
          warehouse: warehouseItems.value.length,
          delete: deleteItems.value.length,
          use: useItems.value.length
        })
        
        // 调试：查看所有道具数据
        console.log('所有道具数据:', allItems)
        console.log('使用可见的道具:', useItems.value)
        
        // 特别查看黄金钥匙相关道具
        const goldenKeyItems = allItems.filter(item => 
          item.item_name && item.item_name.includes('黄金钥匙')
        )
        console.log('黄金钥匙相关道具:', goldenKeyItems)
      } catch (error) {
        console.error('加载道具数据失败:', error)
        ElMessage.error('加载道具数据失败: ' + (error.response?.data?.message || error.message))
      }
    }

    // 切换仓库道具选择
    const toggleWarehouseItem = (itemId) => {
      const index = configContent.value.warehouseItems.indexOf(itemId)
      if (index > -1) {
        configContent.value.warehouseItems.splice(index, 1)
      } else {
        configContent.value.warehouseItems.push(itemId)
      }
    }

    // 切换删除道具选择
    const toggleDeleteItem = (itemId) => {
      const index = configContent.value.deleteItems.indexOf(itemId)
      if (index > -1) {
        configContent.value.deleteItems.splice(index, 1)
      } else {
        configContent.value.deleteItems.push(itemId)
      }
    }

    // 切换使用道具选择
    const toggleUseItem = (itemId) => {
      if (!configContent.value.useItems) {
        configContent.value.useItems = []
      }
      const index = configContent.value.useItems.indexOf(itemId)
      if (index > -1) {
        configContent.value.useItems.splice(index, 1)
      } else {
        configContent.value.useItems.push(itemId)
      }
    }

    // 计算属性：判断是否全选
    const isAllWarehouseSelected = computed(() => {
      if (warehouseItems.value.length === 0) return false
      return warehouseItems.value.every(item => configContent.value.warehouseItems.includes(item.id))
    })

    const isAllDeleteSelected = computed(() => {
      if (deleteItems.value.length === 0) return false
      return deleteItems.value.every(item => configContent.value.deleteItems.includes(item.id))
    })

    const isAllUseSelected = computed(() => {
      if (useItems.value.length === 0) return false
      if (!configContent.value.useItems) return false
      return useItems.value.every(item => configContent.value.useItems.includes(item.id))
    })

    // 全选/取消全选方法
    const toggleSelectAllWarehouse = () => {
      if (isAllWarehouseSelected.value) {
        // 取消全选
        configContent.value.warehouseItems = []
      } else {
        // 全选
        configContent.value.warehouseItems = warehouseItems.value.map(item => item.id)
      }
    }

    const toggleSelectAllDelete = () => {
      if (isAllDeleteSelected.value) {
        // 取消全选
        configContent.value.deleteItems = []
      } else {
        // 全选
        configContent.value.deleteItems = deleteItems.value.map(item => item.id)
      }
    }

    const toggleSelectAllUse = () => {
      if (!configContent.value.useItems) {
        configContent.value.useItems = []
      }
      if (isAllUseSelected.value) {
        // 取消全选
        configContent.value.useItems = []
      } else {
        // 全选
        configContent.value.useItems = useItems.value.map(item => item.id)
      }
    }

    // 获取道具等级
    const getItemGrade = (itemName) => {
      if (!itemName) return 'basic'
      
      if (itemName.includes('高级') || itemName.includes('高等') || itemName.includes('顶级') || itemName.includes('传说') || itemName.includes('史诗')) {
        return 'advanced'
      } else if (itemName.includes('中级') || itemName.includes('中等')) {
        return 'intermediate'
      } else if (itemName.includes('初级') || itemName.includes('低级') || itemName.includes('基础')) {
        return 'basic'
      }
      
      // 默认返回基础等级
      return 'basic'
    }

    // 处理图片加载错误
    const handleImageError = (event) => {
      event.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB4PSIzIiB5PSIzIiB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHJ4PSIyIiByeT0iMiIgZmlsbD0iI2YzZjRmNiIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMTAiIGZpbGw9IiM5Y2EzYWYiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIj7plJnor689L3RleHQ+PC9zdmc+'
    }

    // 获取道具背景色CSS类
    const getItemBackgroundColorClass = (backgroundColor) => {
      if (!backgroundColor) return ''
      return `bg-${backgroundColor}`
    }
  
    // 加载配置数据（编辑模式）
    const loadConfigData = async () => {
      if (!isEditMode.value) return

      loading.value = true
      try {
        const response = await getConfig(props.id)
        const config = response.data

        // 填充表单
        configForm.value.name = config.name
        configForm.value.description = config.description || ''

        // 判断是否为默认配置
        isDefaultConfig.value = config.description && config.description.includes('系统为新用户自动创建')

        // 判断是否为共享配置（不是自己创建的）
        const currentUser = JSON.parse(localStorage.getItem('user') || '{}')
        isSharedConfig.value = config.isShared === 1 && config.createdBy !== currentUser.id

        // 填充配置内容
        if (config.content) {
          fillConfigContent(config.content)
          console.log('配置加载完成，道具数据:', {
            warehouseItems: configContent.value.warehouseItems,
            deleteItems: configContent.value.deleteItems
          })
        }

      } catch (error) {
        console.error('加载配置失败:', error)
        ElMessage.error('加载配置失败: ' + (error.response?.data?.message || error.message))
        router.push('/dashboard/scripts')
      } finally {
        loading.value = false
      }
    }

    // 时间格式化辅助函数：将小时转换为 HH:00 格式
    const formatTimeForDisplay = (time) => {
      if (!time) return '09:00'
      // 如果时间不包含冒号，说明只有小时，添加 :00
      return time.includes(':') ? time : `${time.padStart(2, '0')}:00`
    }

    // 填充配置内容到表单
    const fillConfigContent = (content) => {
      // 角色模式
      if (content.角色模式) configContent.value.characterMode = content.角色模式
      
      // 主角色位置
      if (content.主角色位置) configContent.value.mainCharacterPosition = content.主角色位置
      
      // 选区（占坑模式）
      if (content.选区) configContent.value.placeholderZone = content.选区
      
      // 创建角色
      if (content.创建角色) {
        Object.assign(configContent.value.createCharacter, {
          enabled: content.创建角色.启用 ?? false,
          profession: content.创建角色.职业 ?? '奶妈'
        })
      }
      
      // 游戏更新
      if (content.游戏更新) configContent.value.gameUpdate = content.游戏更新
      if (content.自动更新 !== undefined) configContent.value.autoUpdate = content.自动更新
      
      // 代理设置
      if (content.代理类型) configContent.value.proxyType = content.代理类型
      if (content.启用代理 !== undefined) configContent.value.enableProxy = content.启用代理
      
      // 主线任务
      if (content.主线任务) {
        if (content.主线任务.启用 !== undefined) configContent.value.mainQuest.enabled = content.主线任务.启用
        if (content.主线任务.等级) configContent.value.mainQuest.level = content.主线任务.等级
        if (content.主线任务.死亡限制) configContent.value.mainQuest.deathLimit = content.主线任务.死亡限制
        if (content.主线任务.冷却小时) configContent.value.mainQuest.cooldownHours = content.主线任务.冷却小时
      }
      
      // 故事&成就&黑色女武神
      if (content.故事成就黑色女武神) {
        Object.assign(configContent.value.storyAchievement, {
          exchangeTask: content.故事成就黑色女武神.交易所任务 ?? false,
          ultimateTask: content.故事成就黑色女武神.大招任务 ?? false,
          blueBird: content.故事成就黑色女武神.蓝鸟 ?? false,
          purpleBird: content.故事成就黑色女武神.紫鸟 ?? false
        })
      }
      
      // 系统设置
      if (content.系统设置) {
        Object.assign(configContent.value.systemSettings, {
          autoStart: content.系统设置.开机自启动 ?? false,
          ailinSystem: content.系统设置.艾琳系统 ?? false,
          randomDelayStart: content.系统设置.随机延时启动 ?? false,
          autoUpdateScript: content.系统设置.自动更新脚本 ?? false,
          "谷歌登录界面选择": content.系统设置.谷歌登录界面选择 ?? "直接登录"
        })
      }
      
      // 游戏商城（独立配置）
      if (content.游戏商城) {
        Object.assign(configContent.value.gameShop, {
          autoBuyMana: content.游戏商城.自动商场买蓝 ?? false,
          weaponStone: content.游戏商城.武器强化石 ?? false,
          clothesStone: content.游戏商城.服饰强化石 ?? false,
          accessoryStone: content.游戏商城.饰品强化石 ?? false,
          hammerStone: content.游戏商城.镐锤强化石 ?? false,
          weaponStoneBox: content.游戏商城.武器强化石箱子 ?? false,
          clothesStoneBox: content.游戏商城.服饰强化石箱子 ?? false,
          accessoryStoneBox: content.游戏商城.饰品强化石箱子 ?? false,
          hammerStoneBox: content.游戏商城.镐锤强化石箱子 ?? false,
          honeyWine: content.游戏商城.蜜蜂酒 ?? false,
          foodPack: content.游戏商城.食物包 ?? false
        })
      }
      
      // 副本
      if (content.副本) {
        if (content.副本.女武神的殿堂西侧) {
          Object.assign(configContent.value.dungeons.valkyrie, {
            enabled: content.副本.女武神的殿堂西侧.启用,
            floor: content.副本.女武神的殿堂西侧.层数,
            difficulty: content.副本.女武神的殿堂西侧.难度,
            type: content.副本.女武神的殿堂西侧.类型,
            mapCircle: content.副本.女武神的殿堂西侧.地图绕圈打 ?? false,
            timeLimit: {
              enabled: content.副本.女武神的殿堂西侧.时间限制?.启用 ?? false,
              startTime: formatTimeForDisplay(content.副本.女武神的殿堂西侧.时间限制?.开始时间),
              endTime: formatTimeForDisplay(content.副本.女武神的殿堂西侧.时间限制?.结束时间)
            }
          })
        }
        if (content.副本.西格伦的迷宫西侧) {
          Object.assign(configContent.value.dungeons.sigren, {
            enabled: content.副本.西格伦的迷宫西侧.启用,
            floor: content.副本.西格伦的迷宫西侧.层数,
            difficulty: content.副本.西格伦的迷宫西侧.难度,
            position: content.副本.西格伦的迷宫西侧.位置,
            timeLimit: {
              enabled: content.副本.西格伦的迷宫西侧.时间限制?.启用 ?? false,
              startTime: formatTimeForDisplay(content.副本.西格伦的迷宫西侧.时间限制?.开始时间),
              endTime: formatTimeForDisplay(content.副本.西格伦的迷宫西侧.时间限制?.结束时间)
            }
          })
        }
        if (content.副本.波尔克房间西侧) {
          Object.assign(configContent.value.dungeons.polk, {
            enabled: content.副本.波尔克房间西侧.启用,
            floor: content.副本.波尔克房间西侧.层数,
            difficulty: content.副本.波尔克房间西侧.难度,
            position: content.副本.波尔克房间西侧.位置,
            type: content.副本.波尔克房间西侧.类型,
            timeLimit: {
              enabled: content.副本.波尔克房间西侧.时间限制?.启用 ?? false,
              startTime: formatTimeForDisplay(content.副本.波尔克房间西侧.时间限制?.开始时间),
              endTime: formatTimeForDisplay(content.副本.波尔克房间西侧.时间限制?.结束时间)
            }
          })
        }
      }
      
      // 野外
      if (content.野外) {
        if (content.野外.类型) configContent.value.outdoor.type = content.野外.类型
        if (content.野外.位置) configContent.value.outdoor.location = content.野外.位置
        if (content.野外.定点挂机) configContent.value.outdoor.position = content.野外.定点挂机
        if (content.野外.自动开箱 !== undefined) configContent.value.outdoor.autoChest = content.野外.自动开箱
        // 普通地图时间限制
        if (content.野外.时间限制) {
          Object.assign(configContent.value.outdoor.timeLimit, {
            enabled: content.野外.时间限制.启用 ?? false,
            startTime: formatTimeForDisplay(content.野外.时间限制.开始时间),
            endTime: formatTimeForDisplay(content.野外.时间限制.结束时间)
          })
        }
        // 挖琥珀配置
        if (content.野外.挖琥珀) {
          Object.assign(configContent.value.outdoor.amber, {
            enabled: content.野外.挖琥珀.启用 ?? false,
            location: content.野外.挖琥珀.位置 ?? '世界树一层',
            timeLimit: {
              enabled: content.野外.挖琥珀.时间限制?.启用 ?? false,
              startTime: formatTimeForDisplay(content.野外.挖琥珀.时间限制?.开始时间),
              endTime: formatTimeForDisplay(content.野外.挖琥珀.时间限制?.结束时间)
            }
          })
        }
        // 激战地配置
        if (content.野外.激战地) {
          Object.assign(configContent.value.outdoor.battleground, {
            enabled: content.野外.激战地.启用 ?? false,
            location: content.野外.激战地.位置 ?? '45级激战地',
            position: content.野外.激战地.定点挂机 ?? '随机',
            deathCount: content.野外.激战地.死亡次数 ?? 3,
            timeLimit: {
              enabled: content.野外.激战地.时间限制?.启用 ?? false,
              startTime: formatTimeForDisplay(content.野外.激战地.时间限制?.开始时间),
              endTime: formatTimeForDisplay(content.野外.激战地.时间限制?.结束时间)
            }
          })
        }
      }
      
      // 挂机设置
      if (content.挂机设置) {
        Object.assign(configContent.value.hangSettings, {
          autoBuyPotion: content.挂机设置.自动买药,
          powerSaveMode: content.挂机设置.省电模式,
          healthThreshold: content.挂机设置.血量阈值,
          potionInterval: content.挂机设置.买药间隔 ?? 4,
          nightMode: content.挂机设置.夜晚模式 ?? false
        })
      }
      
      // 其他需求
      if (content.其他需求) {
        Object.assign(configContent.value.otherRequirements, {
          commission: content.其他需求.委托 ?? true,
          sideQuest: content.其他需求.支线 ?? true,
          commissionFailHours: content.其他需求.委托失败小时 ?? 3,
          autoDecomposeEquip: content.其他需求.自动分解装备 ?? true,
          decomposeSkillBook: content.其他需求.分解技能书 ?? false,
          autoEnhance: content.其他需求.自动强化 ?? true,
          autoValkyrieCompose: content.其他需求.自动女武神合成 ?? true,
          autoPetCompose: content.其他需求.自动宠物合成 ?? true,
          autoEquipValkyrie: content.其他需求.自动穿戴女武神卡 ?? true,
          autoEquipPet: content.其他需求.自动穿戴宠物 ?? true,
          autoAmberBox: content.其他需求.自动琥珀封箱 ?? false,
          autoEquipBox: content.其他需求.自动开装备箱子 ?? false,
          autoMaterialCompose: content.其他需求.自动合成材料 ?? false,
          autoBuySkill: content.其他需求.自动购买技能 ?? false,
          autoWarehouse: content.其他需求.自动仓库 ?? false,
          autoUltimate: content.其他需求.自动释放大招 ?? false,
          silverRestoreEnabled: content.其他需求.银币恢复启用 ?? false,
          silverRestore: content.其他需求.银币恢复 ?? 20000,
          seasonInstruction: content.其他需求.赛季指令 ?? false
        })
      }
      
      // 工会
      if (content.工会) {
        Object.assign(configContent.value.guild, {
          autoJoin: content.工会.自动加入,
          techContribute24: content.工会['24次科技捐献'] ?? content.工会.自动贡献 ?? true, // 向后兼容
          silverContribute: content.工会.银币捐献 ?? false,
          collectGuildChest: content.工会.领取工会箱子 ?? false,
          guildHelp: content.工会.工会帮助 ?? false
        })
      }
      
      
      // 交易所
      if (content.交易所) {
        Object.assign(configContent.value.tradingPost, {
          autoSell: content.交易所.自动出售,
          minPrice: content.交易所.最低价格,
          prioritizeAmberBox: content.交易所.优先上架琥珀箱 ?? false,
          enablePriceDifference: content.交易所.启用价格差 ?? false,
          priceDifference: content.交易所.价格差 ?? 1,
          delistHours: content.交易所.下架超过小时 ?? 5
        })
      }
      
      // 收藏区域
      if (content.收藏区域) {
        Object.assign(configContent.value.collection, {
          enabled: content.收藏区域.收藏开关 ?? false,
          maxPrice: content.收藏区域.最高价格 ?? 0.5
        })
        if (content.收藏区域.装备品质) {
          Object.assign(configContent.value.collection.equipmentQuality, {
            white: content.收藏区域.装备品质.白 ?? true,
            green: content.收藏区域.装备品质.绿 ?? true,
            blue: content.收藏区域.装备品质.蓝 ?? false
          })
        }
      }
      
      // BOSS区域
      if (content.BOSS区域) {
        // 处理远征5人配置（向后兼容）
        if (typeof content.BOSS区域.远征5人 === 'boolean') {
          configContent.value.bossArea.expedition5.enabled = content.BOSS区域.远征5人
          configContent.value.bossArea.expedition5.level = 'auto'
          configContent.value.bossArea.expedition5.createRoom = false
        } else if (content.BOSS区域.远征5人) {
          Object.assign(configContent.value.bossArea.expedition5, {
            enabled: content.BOSS区域.远征5人.启用 ?? false,
            level: content.BOSS区域.远征5人.等级 ?? 'auto',
            createRoom: content.BOSS区域.远征5人.没有队伍就开房间 ?? false
          })
        }
        
        // 处理远征15人配置（向后兼容）
        if (typeof content.BOSS区域.远征15人 === 'boolean') {
          configContent.value.bossArea.expedition15.enabled = content.BOSS区域.远征15人
          configContent.value.bossArea.expedition15.level = 'auto'
          configContent.value.bossArea.expedition15.createRoom = false
        } else if (content.BOSS区域.远征15人) {
          Object.assign(configContent.value.bossArea.expedition15, {
            enabled: content.BOSS区域.远征15人.启用 ?? false,
            level: content.BOSS区域.远征15人.等级 ?? 'auto',
            createRoom: content.BOSS区域.远征15人.没有队伍就开房间 ?? false
          })
        }
        
        Object.assign(configContent.value.bossArea, {
          worldBoss: content.BOSS区域.世界boss ?? false,
          timeLimit: {
            enabled: content.BOSS区域.时间限制?.启用 ?? false,
            startTime: formatTimeForDisplay(content.BOSS区域.时间限制?.开始时间),
            endTime: formatTimeForDisplay(content.BOSS区域.时间限制?.结束时间)
          }
        })
      }
      
      // 道具选择
      if (content.需要存仓库的道具) {
        configContent.value.warehouseItems = content.需要存仓库的道具
      }
      if (content.需要删除的垃圾道具) {
        configContent.value.deleteItems = content.需要删除的垃圾道具
      }
      if (content.需要使用的道具) {
        configContent.value.useItems = content.需要使用的道具
      }
      
      // 兼容旧配置格式
      if (content.自定义删除) {
        configContent.value.deleteItems = content.自定义删除
      }
    }

    // 保存配置
    const saveConfig = async () => {
      if (!configForm.value.name.trim()) {
        ElMessage.error('请输入配置名称')
        return
      }
      
      saving.value = true
      try {
        console.log('保存配置，道具数据:', {
          warehouseItems: configContent.value.warehouseItems,
          deleteItems: configContent.value.deleteItems
        })
        
        const configData = {
          name: configForm.value.name,
          description: configForm.value.description,
          game: '尤弥尔传奇韩服',
          content: {
            角色模式: configContent.value.characterMode,
            主角色位置: configContent.value.mainCharacterPosition,
            选区: configContent.value.placeholderZone,
            创建角色: {
              启用: configContent.value.createCharacter.enabled,
              职业: configContent.value.createCharacter.profession
            },
            游戏更新: configContent.value.gameUpdate,
            自动更新: configContent.value.autoUpdate,
            代理类型: configContent.value.proxyType,
            启用代理: configContent.value.enableProxy,
            主线任务: {
              启用: configContent.value.mainQuest.enabled,
              等级: configContent.value.mainQuest.level,
              死亡限制: configContent.value.mainQuest.deathLimit,
              冷却小时: configContent.value.mainQuest.cooldownHours
            },
            故事成就黑色女武神: {
              交易所任务: configContent.value.storyAchievement.exchangeTask,
              大招任务: configContent.value.storyAchievement.ultimateTask,
              蓝鸟: configContent.value.storyAchievement.blueBird,
              紫鸟: configContent.value.storyAchievement.purpleBird
            },
            系统设置: {
              开机自启动: configContent.value.systemSettings.autoStart,
              艾琳系统: configContent.value.systemSettings.ailinSystem,
              随机延时启动: configContent.value.systemSettings.randomDelayStart,
              自动更新脚本: configContent.value.systemSettings.autoUpdateScript,
              谷歌登录界面选择: configContent.value.systemSettings['谷歌登录界面选择']
            },
            游戏商城: {
              自动商场买蓝: configContent.value.gameShop.autoBuyMana,
              武器强化石: configContent.value.gameShop.weaponStone,
              服饰强化石: configContent.value.gameShop.clothesStone,
              饰品强化石: configContent.value.gameShop.accessoryStone,
              镐锤强化石: configContent.value.gameShop.hammerStone,
              武器强化石箱子: configContent.value.gameShop.weaponStoneBox,
              服饰强化石箱子: configContent.value.gameShop.clothesStoneBox,
              饰品强化石箱子: configContent.value.gameShop.accessoryStoneBox,
              镐锤强化石箱子: configContent.value.gameShop.hammerStoneBox,
              蜜蜂酒: configContent.value.gameShop.honeyWine,
              食物包: configContent.value.gameShop.foodPack
            },
            副本: {
              女武神的殿堂西侧: {
                启用: configContent.value.dungeons.valkyrie.enabled,
                层数: configContent.value.dungeons.valkyrie.floor,
                难度: configContent.value.dungeons.valkyrie.difficulty,
                类型: configContent.value.dungeons.valkyrie.type,
                地图绕圈打: configContent.value.dungeons.valkyrie.mapCircle,
                时间限制: {
                  启用: configContent.value.dungeons.valkyrie.timeLimit.enabled,
                  开始时间: configContent.value.dungeons.valkyrie.timeLimit.startTime.split(':')[0],
                  结束时间: configContent.value.dungeons.valkyrie.timeLimit.endTime.split(':')[0]
                }
              },
              西格伦的迷宫西侧: {
                启用: configContent.value.dungeons.sigren.enabled,
                层数: configContent.value.dungeons.sigren.floor,
                难度: configContent.value.dungeons.sigren.difficulty,
                位置: configContent.value.dungeons.sigren.position,
                时间限制: {
                  启用: configContent.value.dungeons.sigren.timeLimit.enabled,
                  开始时间: configContent.value.dungeons.sigren.timeLimit.startTime.split(':')[0],
                  结束时间: configContent.value.dungeons.sigren.timeLimit.endTime.split(':')[0]
                }
              },
              波尔克房间西侧: {
                启用: configContent.value.dungeons.polk.enabled,
                层数: configContent.value.dungeons.polk.floor,
                难度: configContent.value.dungeons.polk.difficulty,
                位置: configContent.value.dungeons.polk.position,
                类型: configContent.value.dungeons.polk.type,
                时间限制: {
                  启用: configContent.value.dungeons.polk.timeLimit.enabled,
                  开始时间: configContent.value.dungeons.polk.timeLimit.startTime.split(':')[0],
                  结束时间: configContent.value.dungeons.polk.timeLimit.endTime.split(':')[0]
                }
              }
            },
            野外: {
              类型: configContent.value.outdoor.type,
              位置: configContent.value.outdoor.location,
              定点挂机: configContent.value.outdoor.position,
              自动开箱: configContent.value.outdoor.autoChest,
              时间限制: {
                启用: configContent.value.outdoor.timeLimit.enabled,
                开始时间: configContent.value.outdoor.timeLimit.startTime.split(':')[0],
                结束时间: configContent.value.outdoor.timeLimit.endTime.split(':')[0]
              },
              挖琥珀: {
                启用: configContent.value.outdoor.amber.enabled,
                位置: configContent.value.outdoor.amber.location,
                时间限制: {
                  启用: configContent.value.outdoor.amber.timeLimit.enabled,
                  开始时间: configContent.value.outdoor.amber.timeLimit.startTime.split(':')[0],
                  结束时间: configContent.value.outdoor.amber.timeLimit.endTime.split(':')[0]
                }
              },
              激战地: {
                启用: configContent.value.outdoor.battleground.enabled,
                位置: configContent.value.outdoor.battleground.location,
                定点挂机: configContent.value.outdoor.battleground.position,
                死亡次数: configContent.value.outdoor.battleground.deathCount,
                时间限制: {
                  启用: configContent.value.outdoor.battleground.timeLimit.enabled,
                  开始时间: configContent.value.outdoor.battleground.timeLimit.startTime.split(':')[0],
                  结束时间: configContent.value.outdoor.battleground.timeLimit.endTime.split(':')[0]
                }
              }
            },
            挂机设置: {
              自动买药: configContent.value.hangSettings.autoBuyPotion,
              省电模式: configContent.value.hangSettings.powerSaveMode,
              血量阈值: configContent.value.hangSettings.healthThreshold,
              买药间隔: configContent.value.hangSettings.potionInterval,
              夜晚模式: configContent.value.hangSettings.nightMode
            },
            其他需求: {
              委托: configContent.value.otherRequirements.commission,
              支线: configContent.value.otherRequirements.sideQuest,
              委托失败小时: configContent.value.otherRequirements.commissionFailHours,
              自动分解装备: configContent.value.otherRequirements.autoDecomposeEquip,
              分解技能书: configContent.value.otherRequirements.decomposeSkillBook,
              自动强化: configContent.value.otherRequirements.autoEnhance,
              自动女武神合成: configContent.value.otherRequirements.autoValkyrieCompose,
              自动宠物合成: configContent.value.otherRequirements.autoPetCompose,
              自动穿戴女武神卡: configContent.value.otherRequirements.autoEquipValkyrie,
              自动穿戴宠物: configContent.value.otherRequirements.autoEquipPet,
              自动琥珀封箱: configContent.value.otherRequirements.autoAmberBox,
              自动开装备箱子: configContent.value.otherRequirements.autoEquipBox,
              自动合成材料: configContent.value.otherRequirements.autoMaterialCompose,
              自动购买技能: configContent.value.otherRequirements.autoBuySkill,
              自动仓库: configContent.value.otherRequirements.autoWarehouse,
              自动释放大招: configContent.value.otherRequirements.autoUltimate,
              银币恢复: configContent.value.otherRequirements.silverRestore,
              银币恢复启用: configContent.value.otherRequirements.silverRestoreEnabled,
              赛季指令: configContent.value.otherRequirements.seasonInstruction
            },
            工会: {
              自动加入: configContent.value.guild.autoJoin,
              '24次科技捐献': configContent.value.guild.techContribute24,
              银币捐献: configContent.value.guild.silverContribute,
              领取工会箱子: configContent.value.guild.collectGuildChest,
              工会帮助: configContent.value.guild.guildHelp
            },
            交易所: {
              自动出售: configContent.value.tradingPost.autoSell,
              最低价格: configContent.value.tradingPost.minPrice,
              优先上架琥珀箱: configContent.value.tradingPost.prioritizeAmberBox,
              启用价格差: configContent.value.tradingPost.enablePriceDifference,
              价格差: configContent.value.tradingPost.priceDifference,
              下架超过小时: configContent.value.tradingPost.delistHours
            },
            收藏区域: {
              收藏开关: configContent.value.collection.enabled,
              最高价格: configContent.value.collection.maxPrice,
              装备品质: {
                白: configContent.value.collection.equipmentQuality.white,
                绿: configContent.value.collection.equipmentQuality.green,
                蓝: configContent.value.collection.equipmentQuality.blue
              }
            },
            BOSS区域: {
              远征5人: {
                启用: configContent.value.bossArea.expedition5.enabled,
                等级: configContent.value.bossArea.expedition5.level,
                没有队伍就开房间: configContent.value.bossArea.expedition5.createRoom
              },
              远征15人: {
                启用: configContent.value.bossArea.expedition15.enabled,
                等级: configContent.value.bossArea.expedition15.level,
                没有队伍就开房间: configContent.value.bossArea.expedition15.createRoom
              },
              世界boss: configContent.value.bossArea.worldBoss,
              时间限制: {
                启用: configContent.value.bossArea.timeLimit.enabled,
                开始时间: configContent.value.bossArea.timeLimit.startTime.split(':')[0],
                结束时间: configContent.value.bossArea.timeLimit.endTime.split(':')[0]
              }
            },
            需要存仓库的道具: configContent.value.warehouseItems,
            需要删除的垃圾道具: configContent.value.deleteItems,
            需要使用的道具: configContent.value.useItems
          }
        }

        if (isEditMode.value) {
          // 更新配置
          await updateConfig(props.id, configData)
          ElMessage.success('配置更新成功')
        } else {
          // 创建配置
          await createConfig(configData)
          ElMessage.success('配置创建成功')
        }
        
        router.push('/dashboard/scripts')
      } catch (error) {
        console.error('保存配置失败:', error)
        ElMessage.error('保存配置失败: ' + (error.response?.data?.message || error.message))
      } finally {
        saving.value = false
      }
    }
  

    onMounted(async () => {
      await Promise.all([
        loadConfigData(),
        loadGameItems()
      ])
    })
  
    return {
      configForm,
      configContent,
      saving,
      loading,
      activeTab,
      isEditMode,
      isDefaultConfig,
      isSharedConfig,
      outdoorOptions,
      warehouseItems,
      deleteItems,
      useItems,
      onOutdoorTypeChange,
      toggleWarehouseItem,
      toggleDeleteItem,
      toggleUseItem,
      // 全选相关
      isAllWarehouseSelected,
      isAllDeleteSelected,
      isAllUseSelected,
      toggleSelectAllWarehouse,
      toggleSelectAllDelete,
      toggleSelectAllUse,
      getItemGrade,
      handleImageError,
      getItemBackgroundColorClass,
      saveConfig
    }
  }
}
</script>

<style scoped>
.config-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  background: #fafbfc;
}

/* Reduced header padding for more compact layout */
.config-header {
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border-bottom: 1px solid #e2e8f0;
  padding: 8px 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.header-left {
  flex: 1;
}

.config-header h2 {
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
}

.header-notice {
  max-width: 400px;
  height: 80%;
      background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border: 1px solid #64748b;
    border-radius: 6px;
    padding: 8px;
    box-shadow: 0 2px 8px rgba(100, 116, 139, 0.1);
  display: flex;
  align-items: center;
}

.notice-content-compact h4 {
  margin: 0 0 4px 0;
  font-size: 13px;
  font-weight: 600;
  color: #1d4ed8;
}

.notice-content-compact p {
  margin: 1px 0;
  font-size: 11px;
  color: #1e40af;
  line-height: 1.3;
}

.notice-content-compact strong {
  color: #1d4ed8;
  font-weight: 600;
}

.header-controls {
  display: flex;
  align-items: center;
  gap: 12px;
}

.config-name-group,
.config-description-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.config-name-group label,
.config-description-group label {
  font-size: 14px;
  color: #475569;
  font-weight: 500;
}

.config-name-input,
.config-description-input {
  padding: 6px 10px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  background: white;
  transition: border-color 0.2s ease;
  width: 200px;
}

.config-description-input {
  width: 300px;
}

.config-name-input:focus,
.config-description-input:focus {
  outline: none;
  border-color: #64748b;
  box-shadow: 0 0 0 3px rgba(100, 116, 139, 0.1);
}

.save-btn {
  background: #475569;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.save-btn:hover:not(:disabled) {
  background: #334155;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.save-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.shared-config-notice {
  color: #ff9500;
  font-size: 14px;
  font-weight: 500;
  padding: 10px 20px;
  background: rgba(255, 149, 0, 0.1);
  border-radius: 6px;
  display: inline-block;
}

/* Simplified loading overlay */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(248, 250, 252, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(2px);
}

.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.loading-spinner .spinner {
  width: 32px;
  height: 32px;
  border: 2px solid #e2e8f0;
      border-top: 2px solid #64748b;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.loading-spinner p {
  color: #475569;
  font-size: 14px;
  margin: 0;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.config-name-input:disabled {
  background: #f8fafc;
  color: #64748b;
  cursor: not-allowed;
}

.config-content {
  flex: 1;
  padding: 12px;
  background: #fafbfc;
  overflow-x: auto;
  overflow-y: auto;
}

/* Tab样式 */
.tab-container {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.tab-nav {
  display: flex;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  justify-content: flex-start;
  gap: 0;
}

.tab-button {
  width: 100px;
  padding: 12px 16px;
  border: none;
  background: transparent;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 3px solid transparent;
}

.tab-button:hover {
  background: #f1f5f9;
  color: #475569;
}

  .tab-button.active {
    background: #ffffff;
    color: #475569;
    border-bottom-color: #475569;
  }

/* 教程文本链接样式 */
.tutorial-text-link {
  color: #3b82f6;
  text-decoration: none;
  font-size: 12px;
  font-weight: 500;
  transition: color 0.2s ease;
}

.tutorial-text-link:hover {
  color: #1d4ed8;
  text-decoration: underline;
}

.tab-content {
  background: #ffffff;
}

.tab-pane {
  padding: 16px;
  min-height: auto;
  min-width: 1200px; /* 设置最小宽度以确保内容完整显示 */
}

.items-config-container {
  width: 100%;
  margin: 0;
}


/* Reduced margins and padding for more compact sections */
.grouped-section {
  margin-bottom: 8px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.grouped-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 8px;
  height: 100%;
  align-content: start;
}

.right-sections-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 100%;
}

.compact-section {
  padding: 0;
  background: transparent;
}

.bordered-section {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 8px;
  background: #ffffff;
}

/* 野外挂机子区域样式 */
.outdoor-subsection {
  margin-bottom: 12px;
  padding: 6px 0;
}

.outdoor-subsection:not(:last-child) {
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 12px;
}

.subsection-title {
  font-size: 13px;
  font-weight: 600;
  color: #475569;
  margin: 0 0 8px 0;
  padding-left: 4px;
  border-left: 3px solid #64748b;
}

/* 挖琥珀内联提示样式 */
.inline-notice {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}

/* 激战地提示样式 */
.battleground-notice {
  margin-bottom: 8px;
}

.notice-content {
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 4px;
  padding: 6px 8px;
  display: flex;
  align-items: center;
}

.notice-text {
  font-size: 12px;
  color: #dc2626;
  line-height: 1.4;
}

.compact-title {
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
}

/* Reduced note padding and margin */
.compact-note {
  font-size: 13px;
  color: #92400e;
  margin-bottom: 12px;
  padding: 8px;
  background: #fef3c7;
  border-radius: 6px;
  border-left: 3px solid #d97706;
}

.form-section {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.section-title {
  margin: 0 0 12px 0;
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  padding-bottom: 6px;
  border-bottom: 1px solid #e2e8f0;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.section-header .section-title {
  margin: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.select-all-btn {
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.select-all-btn:hover:not(:disabled) {
  background: #2563eb;
  transform: translateY(-1px);
}

.select-all-btn:active:not(:disabled) {
  background: #1d4ed8;
  transform: translateY(0);
}

.select-all-btn:disabled {
  background: #94a3b8;
  cursor: not-allowed;
  transform: none;
}

/* 时间设置样式 */
.time-settings {
  margin-top: 12px;
  margin-bottom: 12px;
  padding: 8px;
  background: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #e9ecef;
}

.time-range {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  flex-wrap: wrap;
}

.time-separator {
  color: #666;
  font-size: 12px;
  white-space: nowrap;
  font-weight: 500;
}

/* 时间选择下拉框样式 */
.time-range .el-select {
  flex-shrink: 0;
}

.time-range .el-select .el-select__wrapper {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  border: 1px solid #ddd;
}

.time-range .el-select .el-select__wrapper:hover {
  border-color: #409EFF;
}

/* BOSS时间提示样式 */
.boss-time-notice {
  margin-top: 8px;
  padding: 8px;
  background: #e8f4fd;
  border: 1px solid #b3d8ff;
  border-radius: 4px;
}

.boss-time-notice .notice-content {
  display: flex;
  align-items: flex-start;
  gap: 6px;
}

.boss-time-notice .notice-text {
  font-size: 12px;
  line-height: 1.4;
  color: #1976d2;
}

/* 夜晚模式提示样式 */
.night-mode-notice {
  margin-left: 8px;
  display: inline-block;
}

.night-mode-notice .notice-text {
  font-size: 11px;
  color: #666;
  font-style: italic;
}

/* 远征设置样式 */
.expedition-setting {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.expedition-setting .el-checkbox {
  width: 60px;
  flex-shrink: 0;
}

.expedition-setting .el-select {
  flex-shrink: 0;
}

/* 5人远征行间距调整 */
.expedition-5-row {
  margin-top: 8px;
}

/* 远征内联选项样式 */
.expedition-inline-option {
  margin-left: 6px;
  font-size: 12px;
}

.expedition-inline-option.is-disabled {
  opacity: 0.5;
}

/* 移动端时间设置优化 */
@media (max-width: 768px) {
  .time-range {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }
  
  .time-range .el-select {
    width: 60px !important;
  }

  .night-mode-notice {
    margin-left: 0;
    margin-top: 4px;
    display: block;
  }

  .expedition-setting {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .expedition-setting .el-select {
    width: 100px !important;
  }

  .expedition-inline-option {
    margin-left: 4px !important;
  }
}

.section-note {
  font-size: 13px;
  color: #92400e;
  margin-bottom: 12px;
  background: #fef3c7;
  padding: 8px;
  border-radius: 6px;
  border-left: 3px solid #d97706;
}

.main-content-grid {
  display: grid;
  grid-template-columns: 1fr 1.5fr 1fr;
  gap: 8px;
  margin-bottom: 8px;
  align-items: stretch;
  min-width: 1100px; /* 确保网格布局有足够空间 */
}

.main-content-grid > .form-section {
  display: flex;
  flex-direction: column;
}

.full-width {
  grid-column: 1 / -1;
}

.form-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4px 12px;
  margin-bottom: 8px;
}

.checkbox-compact {
  margin-bottom: 8px;
}

.checkbox-row {
  display: flex;
  gap: 20px;
  margin-bottom: 6px;
  align-items: center;
  justify-content: flex-start;
}

.shop-rows .checkbox-row {
  gap: 16px;
}

.checkbox-row:last-child {
  margin-bottom: 0;
}

.checkbox-grid-aligned {
  display: grid;
  grid-template-columns: 150px 150px 150px;
  gap: 6px 20px;
  margin-bottom: 8px;
  justify-content: start;
}

.decompose-section {
  margin-bottom: 12px;
}

.decompose-options {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-left: 20px;
  margin-top: 8px;
  padding: 8px;
  background: #f8fafc;
  border-radius: 6px;
  border: 1px solid #e8edf3;
}

.checkbox-grid-2x2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 12px;
  margin-bottom: 8px;
}

.checkbox-grid-aligned2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 8px;
  row-gap: 4px;
  margin-bottom: 8px;
  max-width: 100%;
}

.single-line {
  flex-wrap: nowrap;
}

.form-row label {
  font-size: 14px;
  color: #475569;
  white-space: nowrap;
  font-weight: 500;
}

.form-label {
  font-size: 14px;
  color: #475569;
  white-space: nowrap;
}

.small-text {
  font-size: 13px;
  color: #64748b;
}

/* Simple number input */
.simple-number-input {
  width: 50px;
  height: 24px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  text-align: center;
  font-size: 12px;
  color: #1e293b;
  background: #ffffff;
  outline: none;
  transition: border-color 0.2s ease;
}

.simple-number-input:focus {
  border-color: #64748b;
  box-shadow: 0 0 0 2px rgba(100, 116, 139, 0.1);
}

.simple-number-input:hover {
  border-color: #64748b;
}

.dungeon-item {
  margin-bottom: 12px;
  padding: 12px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.dungeon-settings {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
  flex-wrap: wrap;
}

.dungeon-settings label {
  font-size: 13px;
  color: #475569;
  white-space: nowrap;
  font-weight: 500;
}

.inventory-section {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #e2e8f0;
}

.item-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
  gap: 12px;
  margin-top: 12px;
}

/* 道具容器 */
.item-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.item-container:hover .item-icon {
  border-color: #64748b;
}

.item-container.selected .item-icon {
  border-color: #64748b;
  background: #f1f5f9;
}

/* 选中状态下保持背景色和边框色 */
.item-container.selected .item-icon.bg-light-green {
  background: linear-gradient(135deg, #c8e6c9 0%, #a5d6a7 100%);
  border-color: #66bb6a;
}

.item-container.selected .item-icon.bg-light-blue {
  background: linear-gradient(135deg, #bbdefb 0%, #90caf9 100%);
  border-color: #42a5f5;
}

.item-container.selected .item-icon.bg-light-purple {
  background: linear-gradient(135deg, #e1bee7 0%, #ce93d8 100%);
  border-color: #ab47bc;
}

.item-container.selected .item-icon.bg-light-gold {
  background: linear-gradient(135deg, #ffe082 0%, #ffd54f 100%);
  border-color: #ffb300;
}

/* 道具等级背景颜色 */
.item-container.grade-advanced .item-icon {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-color: #2196f3;
}

.item-container.grade-intermediate .item-icon {
  background: linear-gradient(135deg, #e8f5e8 0%, #c8e6c9 100%);
  border-color: #4caf50;
}

.item-container.grade-basic .item-icon {
  background: linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%);
  border-color: #9e9e9e;
}

/* 选中状态下的等级颜色 */
.item-container.grade-advanced.selected .item-icon {
  background: linear-gradient(135deg, #bbdefb 0%, #90caf9 100%);
  border-color: #1976d2;
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.4);
}

.item-container.grade-intermediate.selected .item-icon {
  background: linear-gradient(135deg, #c8e6c9 0%, #a5d6a7 100%);
  border-color: #388e3c;
  box-shadow: 0 2px 8px rgba(56, 142, 60, 0.4);
}

.item-container.grade-basic.selected .item-icon {
  background: linear-gradient(135deg, #f5f5f5 0%, #eeeeee 100%);
  border-color: #616161;
  box-shadow: 0 2px 8px rgba(97, 97, 97, 0.4);
}

/* Enhanced item icons */
.item-icon {
  width: 70px;
  height: 70px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.2s ease;
  background: #ffffff;
  position: relative;
  margin-bottom: 6px;
}

.item-icon.bg-light-green {
  background: linear-gradient(135deg, #e8f5e8 0%, #c8e6c9 100%);
  border-color: #81c784;
}

.item-icon.bg-light-blue {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-color: #64b5f6;
}

.item-icon.bg-light-purple {
  background: linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%);
  border-color: #ba68c8;
}

.item-icon.bg-light-gold {
  background: linear-gradient(135deg, #fff9e6 0%, #ffe082 100%);
  border-color: #ffc107;
}

.item-icon img {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

/* 道具名称 */
.item-name {
  font-size: 12px;
  color: #4b5563;
  text-align: center;
  max-width: 85px;
  line-height: 1.2;
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.item-checkbox {
  position: absolute;
  bottom: 4px;
  right: 4px;
}

.empty-items {
  text-align: center;
  color: #6b7280;
  font-size: 14px;
  margin-top: 20px;
  padding: 20px;
  border: 1px dashed #d1d5db;
  border-radius: 8px;
  background: #f9fafb;
}

/* 平板设备适配 */
@media (max-width: 1024px) and (min-width: 769px) {
  .main-content-grid {
    grid-template-columns: 1fr 1fr;
    min-width: auto;
  }

  .tab-pane {
    min-width: auto;
  }
}

@media (max-width: 768px) {
  .config-content {
    padding: 8px;
  }

  .tab-pane {
    padding: 12px;
    min-width: auto; /* 移动端移除最小宽度限制 */
    width: 100%;
  }

  .main-content-grid {
    grid-template-columns: 1fr;
    gap: 16px;
    min-width: auto; /* 移动端移除最小宽度限制 */
  }

  .grouped-content {
    grid-template-columns: 1fr;
  }

  .header-content {
    flex-direction: column;
    gap: 16px;
  }

  .header-notice {
    max-width: none;
  }

  .header-controls {
    width: 100%;
    justify-content: space-between;
  }

  .anti-ban-content {
    padding: 10px 12px;
  }
  
  .anti-ban-text {
    font-size: 11px;
  }
}

/* 防封策略说明样式 */
.anti-ban-notice {
  margin: 12px 0 !important;
  padding: 0;
}

.anti-ban-content {
  display: flex;
  align-items: flex-start;
  padding: 12px 16px;
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.05) 0%, rgba(16, 185, 129, 0.02) 100%);
  border: 1px solid rgba(16, 185, 129, 0.2);
  border-radius: 8px;
  margin: 0;
}

.anti-ban-text {
  font-size: 12px;
  line-height: 1.5;
  color: #374151;
  flex: 1;
}

.anti-ban-text strong {
  color: #10b981;
  font-weight: 600;
}

/* 功能特色标签样式 */
.feature-badge {
  display: inline-block;
  font-size: 10px;
  font-weight: 500;
  color: #10b981;
  background: rgba(16, 185, 129, 0.1);
  border: 1px solid rgba(16, 185, 129, 0.2);
  border-radius: 4px;
  padding: 2px 6px;
  margin-left: 8px;
  vertical-align: middle;
}

/* 设置标签样式 */
.setting-label {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  margin-right: 8px;
}

/* 谷歌登录提示样式 */
.google-login-tip {
  margin-top: 8px;
  padding: 0;
}

.tip-content {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding: 8px 12px;
  background: rgba(59, 130, 246, 0.05);
  border: 1px solid rgba(59, 130, 246, 0.15);
  border-radius: 6px;
  font-size: 12px;
  line-height: 1.4;
}

.tip-icon {
  flex-shrink: 0;
  font-size: 14px;
  margin-top: 1px;
}

.tip-text {
  color: #4b5563;
  flex: 1;
}
</style>
